<template>
  <div class="row">
    <div class="col-md-6">
      <b-card :header="displayName">
        {{displayName}}
        <span slot="footer">Go to <!-- <router-link class="font-weight-bold" :to="'/vehicles/' + detailedInfo.id"> -->profile<!-- </router-link> --> page</span>
      </b-card>
      <card-list-info header="Detail" :items="accountInfo"></card-list-info>
      <card-list-info header="Gps Device" :items="gpsDeviceInfo" v-if="activeGps">
        <template slot="status" slot-scope={data}>
          Status : <b-badge variant="success">{{ data.value }}</b-badge>
        </template>
      </card-list-info>
      <card-list-info header="Fleet Equipment" :items="fleetEquipment" v-if="fleetEquipment.length"></card-list-info>
      <card-list-info header="Document" :items="document" v-if="document.length"></card-list-info>
    </div>
    <div class="col-md-6">
      <b-card v-if="amISystemAdmin" header="Transfer vehicle">
        <label>Company</label>
        <multiselect
            v-model="selectedCompany"
            :options="companies"
            label="name"
            track-by="id"
            placeholder="Select company" class="mb-4"/>
        <b-button variant="primary">Transfer</b-button>
      </b-card>
      <b-card header="Assign driver for this vehicle">
        <label>Driver</label>
        <multiselect
            v-model="selectedDriver"
            :options="unassignDrivers"
            label="name"
            track-by="id"
            placeholder="Select driver" class="mb-4"/>
        <b-button variant="primary" @click="assignDriver()">{{ textButtonAssign }}</b-button>
      </b-card>
      <b-card
        v-if="canIEditVehicle(detailedInfo)"
        header-bg-variant="warning" border-variant="warning" header="Disable this vehicle">
        <p>Blocking vehicles has the following effects: </p>
        <ul class="pl-4">
          <li>Vehicle will not be able to login</li>
          <li>Personal token access will be revoked</li>
          <li>Email Report schedule will be stopped</li>
        </ul>
        <b-button variant="warning">Disable</b-button>
      </b-card>
      <b-card
        v-if="canIDeleteVehicle(detailedInfo)"
        header-bg-variant="danger" border-variant="danger" header="Remove this vehicle">
        <p>Removing vehicles has the following effects: </p>
        <ul class="pl-4">
          <li>Custom Reports made by vehicle will be removed</li>
          <li>Email Report schedule will be removed</li>
          <li>Vehicle data will not be retrievable</li>
        </ul>
        <b-button v-b-modal.delete_vehicle variant="danger">Remove</b-button>
      </b-card>
    </div>
    <div>
      <b-modal
        id="delete_vehicle"
        title="Delete Vehicle"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="deleteVehicle()">
        <p class="my-4">Are you sure want to delete this vehicle ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import vehicleMixin from '@/mixins/vehicle';
import { find, isEmpty, isNull } from 'lodash';
import get from 'lodash/get';

import CardListInfo from '@/components/CardListInfo';
import Multiselect from 'vue-multiselect';
import userMixin from './../../../../../mixins/user';

export default {
  mixins: [dateMixin, vehicleMixin, userMixin],
  components: {
    CardListInfo,
    Multiselect,
  },
  data() {
    return {
      selectedCompany: null,
      selectedDriver: null,
      textButtonAssign: 'Assign',
    };
  },
  created() {
    if (this.amISystemAdmin) {
      this.$store.commit('companies/CLEAR_QUERY');
      this.$store.dispatch('companies/LOAD_INFO').then(() => {
        this.$store.commit('companies/SET_QUERY_COUNT', this.company_count_all);
        this.$store.dispatch('companies/LOAD_DATA');
      });
    }
    this.$store.commit('vehicles/CLEAR_DATA');
    this.$store.commit('employees/CLEAR_DATA');
    this.$store.dispatch('vehicles/LOAD_DETAIL_DATA').then(() => {
      if (this.detailedInfo.driver) {
        this.textButtonAssign = 'Change Driver';
        this.selectedDriver = this.detailedInfo.driver;
      }
    });
    this.$store.dispatch('employees/LOAD_INFO').then(() => {
      this.$store.commit('employees/SET_QUERY_COUNT', this.employee_count);
      this.$store.dispatch('employees/LOAD_DATA');
    });
  },
  computed: {
    vehicle_driver() {
      return this.$store.getters['vehicles/get_vehicle_driver'];
    },
    vehicle_driver2() {
      return this.$store.getters['vehicles/get_vehicle_driver2'];
    },
    companies() {
      return this.$store.getters['companies/companies'];
    },
    unassignDrivers() {
      const empDrivers = this.$store.getters['employees/employees'].filter(v => v.type === 'DRIVER');
      return empDrivers;
    },
    displayName() {
      return this.detailedInfo.reg_no;
    },
    detailedInfo() {
      return this.$store.getters['vehicles/get_detail_data'];
    },
    loadedVehicle() {
      return this.$store.getters['vehicles/dataLoaded'];
    },
    employee_count() {
      return this.$store.getters['employees/count_all'];
    },
    company_count_all() {
      return this.$store.getters['companies/count_all'];
    },
    activeGps() {
      let { gps_devices } = this.detailedInfo;
      gps_devices = gps_devices || {};
      let activeGps = find(gps_devices, { metadata: { active: 1 } });
      activeGps = activeGps || {};

      return !isEmpty(activeGps);
    },
    accountInfo() {
      /* eslint-disable */
      const info = this.detailedInfo;

      let standby = '';
      let workingArea = '';
      const metadata = info.metadata;
      if (isNull(metadata) && this.loadedVehicle) {
        workingArea = '-';
      } else if(!isNull(metadata) && this.loadedVehicle) {
        if (metadata.hasOwnProperty('standby')) {
          standby = metadata.standby ? 'STANDBY ' : '';
        } else {
          standby = '';
        }

        if (metadata.hasOwnProperty('working_area')) {
          let str = '';
          if (metadata.working_area.length == 1) {
            str = metadata.working_area.toString();
          } else {
            str = metadata.working_area.join(', ');
          }
          workingArea = `${standby}${str}`;
        } else {
          workingArea = '-';
        }
      }
      const infoList = [
        { key: 'name', label: 'Reg Number', value: info.reg_no, isPrambanan: true},
        { key: 'driver', label: 'Driver', value: !info.driver ? '-' : info.driver.name, isPrambanan: true },
        {
          key: 'created_at',
          label: 'Created at',
          value: this.formatDateDistance(info.created_at),
          title: this.formatDateTime(info.created_at),
          isPrambanan: true
        },
        { key: 'storage_type', label: 'Storage Type', value: info.metadata == null ? '-' : info.metadata.storage_type, isPrambanan: false },
        { key: 'working_area', label: 'Working Area', value: workingArea, isPrambanan: false },
        { key: 'cdd', label: 'Colt Diesel Double (CDD)', value: info.metadata == null ? '-' : (info.metadata.cdd == 0 || isNull(info.metadata.cdd) ? 'No' : 'Yes'), isPrambanan: false },
      ];
      if(this.isPrambananConfig) {
        return infoList;
      } else {
        return infoList.filter((list) => list.isPrambanan);
      }
      // return infoList;
    },
    containerInfo() {
      let { container } = this.detailedInfo;
      container = container || {};

      const infoList = [
        { key: 'type', label: 'Type', value: container.type },
        { key: 'length', label: 'Length', value: container.length },
        { key: 'width', label: 'Width', value: container.width },
        { key: 'height', label: 'Height', value: container.height },
      ];

      return infoList;
    },
    gpsDeviceInfo() {
      let { gps_devices } = this.detailedInfo;
      gps_devices = gps_devices || {};

      let activeGps = find(gps_devices, { metadata: { active: 1 } });
      activeGps = activeGps || {};
      const isActive = this.activeGps && 'Active';

      const infoList = [
        { key: 'number', label: 'Number', value: activeGps.number },
        { key: 'type', label: 'Type', value: activeGps.type },
        { key: 'status', label: 'Status', value: isActive },
      ];

      return infoList;
    },
    fleetEquipment() {
      let fleetEquipment = get(this.detailedInfo, 'metadata.fleet_equipment', []);
      fleetEquipment = fleetEquipment.map((fe, idx) => ({
        key: `fe-${idx}`,
        value: fe
      }));

      return fleetEquipment;
    },
    document() {
      let document = get(this.detailedInfo, 'metadata.document', []);
      document = document.map((d, idx) => ({
        key: `d-${idx}`,
        html: true,
        value: `
          Item: ${d[0]}
          <br>
          Expired Date: ${this.formatDate(d[1])}
        `
      }));
      return document;
    },
    assignInfo() {
      let { driver } = this.detailedInfo;
      driver = driver || null;
      return driver;
    }
  },
  watch: {
    detailedInfo(data) {
      this.selectedCompany = data.company;
    },
  },
  methods: {
    deleteVehicle() {
      this.$store.dispatch('vehicles/DELETE_DATA').then((ok) => {
        if (ok) this.$router.push('/admin/vehicles');
      });
    },
    assignDriver() {
      const data = {
        employee_id: this.selectedDriver.id
      };

      const payloadVehicle = {
        vehicle_id: this.detailedInfo.id
      };

      this.$store.dispatch('vehicles/LOAD_DETAIL_DATA');
      this.$store.dispatch('vehicles/LOAD_VEHICLE_DRIVER2', data);

      const load = this.$store.dispatch('vehicles/LOAD_VEHICLE_DRIVER', payloadVehicle);
      load.then((response) => {
        // if vehicle.driver exist, vehicle_driver response exist, selectDriver.vehicle exist
        if (!isEmpty(this.detailedInfo.driver) && !isEmpty(response) && !isEmpty(this.selectedDriver.vehicle)) {
          this.apiDeleteUpdate(response.id);
        // if vehicle.driver exist, vehicle_driver response exist, selectDriver.vehicle not exist
        } else if (!isEmpty(this.detailedInfo.driver) && !isEmpty(response) && isEmpty(this.selectedDriver.vehicle)) {
          this.apiUpdate(response.id);
        // if vehicle.driver not exist, vehicle_driver response not exist, selectDriver.vehicle exist
        } else if (isEmpty(this.detailedInfo.driver) && isEmpty(response) && !isEmpty(this.selectedDriver.vehicle)) {
          this.apiDeleteCreate();
        // if vehicle.driver not exist, vehicle_driver response not exist, selectDriver.vehicle not exist
        } else {
          this.apiCreate();
        }
      });
    },
    apiCreate() {
      const createData = {
        vehicle_id: this.detailedInfo.id,
        employee_id: this.selectedDriver.id,
      };
      this.$store.dispatch(`vehicles/CREATE_VEHICLE_DRIVER`, createData).then(() => {
        this.successAssignDialog();
      });
    },
    apiUpdate(id) {
      const updateData = {
        id: id,
        employee_id: this.selectedDriver.id,
        vehicle_id: this.detailedInfo.id,
      };
      this.$store.dispatch(`vehicles/UPDATE_VEHICLE_DRIVER`, updateData).then(() => {
        this.successAssignDialog();
      });
    },
    apiDelete() {
      const deleteData = {
        id: this.vehicle_driver2.id,
      };

      return this.$store.dispatch(`vehicles/DELETE_VEHICLE_DRIVER`, deleteData);
    },
    apiDeleteUpdate(id) {
      this.apiDelete().then(() => {
        this.apiUpdate(id);
      });
    },
    apiDeleteCreate() {
      this.apiDelete().then(() => {
        this.apiCreate();
      });
    },
    successAssignDialog() {
      this.$swal('Success', 'Success assign driver to this vehicle', 'success').then(() => {
        location.reload();
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/vehicles/detail/Preview.vue